import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { User } from 'src/app/auth/models/user.model';

/** Customer portal logins: they must belong to a customer, and cannot sign in to Logixi itself. */
export const CUSTOMER_GROUP_NAMES = ['Customer Superuser', 'Customer User'];

@Injectable({
  providedIn: 'root'
})
export class UserValidatorService extends ValidatorService {
  isValid(data: User) {
    this.errors = [];

    if(!this.isSupplied(data.email)) {
      this.errors.push('email');
    }

    if(!this.isSupplied(data.firstName)) {
      this.errors.push('firstName');
    }

    if(!this.isSupplied(data.lastName)) {
      this.errors.push('lastName');
    }

    if(!this.isDropdownSupplied(data.userGroupId)) {
      this.errors.push('userGroupId');
    }

    if(data.userGroup && CUSTOMER_GROUP_NAMES.includes(data.userGroup.name) && !(data.accountId > 0)) {
      this.errors.push('accountId');
    }

    if(data.id === -1) {
      if(!this.isSupplied(data.password)) {
        this.errors.push('password');
      }
    }

    return this.errors.length === 0;
  }
 }
